const translations = {
  // Navigation
  "nav.home": "Home",
  "nav.about": "About",
  "nav.specialties": "Specialties",
  "nav.team": "Team",
  "nav.blog": "Blog",
  "nav.contact": "Contact",
  "nav.schedule": "Schedule Consultation",

  // Hero
  "hero.title": "Tax Preparation You Can Trust in the United States",
  "hero.subtitle": "Personal and business taxes for Brazilians living in the USA, with service in Portuguese, clarity, and security.",
  "hero.description": "We handle your taxes with precision, organization, and full compliance with American laws, so you can have peace of mind and avoid problems with the IRS.",
  "hero.cta": "Schedule Consultation",
  "hero.whatsapp": "Talk to a Specialist",

  // Results
  "results.title": "Numbers Accumulated Over Years of Service",
  "results.individual": "Individual Tax Returns Filed",
  "results.business": "Business Tax Returns Filed",

  // Testimonials
  "testimonials.badge": "Google Reviews",
  "testimonials.title": "What Our Clients Say",
  "testimonials.description": "The trust of those who have been with Amiraco is our greatest proof of quality",
  "testimonials.verified": "All testimonials are real and verified from Google Reviews",
  "testimonials.satisfied": "Satisfied clients",
  "testimonials.recommend": "Would recommend",
  "testimonials.viewGoogle": "View on Google",
  "testimonials.basedOn": "Based on",
  "testimonials.reviewsOn": "reviews on Google",

  // About
  "about.title": "About Amiraco",
  "about.p1": "Amiraco Tax Service is a company specialized in tax and accounting services in the United States, with over 11 years of experience serving individuals and businesses. We focus on precision, tax compliance, and personalized service, offering complete solutions for those seeking security and peace of mind in managing their taxes.",
  "about.p2": "We provide services ranging from the preparation and filing of income tax returns (Tax Return) to consulting and tax planning for companies of different sizes and segments. Our processes are organized, transparent, and fully aligned with American legislation, ensuring efficiency and trust at every step.",
  "about.p3": "We are Enrolled Agents (EA), credentialed by the IRS to represent taxpayers before the tax authority, as well as authorized Acceptance Agents for ITIN services. This allows us to conduct tax processes with a high technical level, security, and agility, without the need to send original documents to the IRS.",
  "about.credential1": "Enrolled Agent (EA) credentialed by the IRS",
  "about.credential2": "Authorized Acceptance Agent for ITIN (no need to send original documents to the IRS)",
  "about.credential3": "Organized and transparent processes aligned with American legislation",

  // Specialties
  "specialties.title": "Our Specialties",
  "specialties.description": "We offer a complete range of tax and accounting services to meet all your needs",
  "specialties.individual": "Services for Individuals",
  "specialties.business": "Services for Businesses and Self-Employed",
  
  "specialties.taxReturn.title": "Tax Return",
  "specialties.taxReturn.desc": "Complete Tax Return for Individual and Family, with detailed analysis and maximization of refunds",
  "specialties.taxExtension.title": "Tax Extension",
  "specialties.taxExtension.desc": "Tax Extension to ensure more time to prepare your return without penalties",
  "specialties.itin.title": "ITIN – Application and Renewal",
  "specialties.itin.desc": "Authorized Acceptance Agent - passport authentication without sending to IRS",
  "specialties.consulting.title": "Tax Consulting",
  "specialties.consulting.desc": "Specialized guidance on tax matters for strategic decision-making",
  "specialties.notary.title": "Notary Public",
  "specialties.notary.desc": "Complete notarization services for documents with legal validity",
  "specialties.passport.title": "Passport Renewal",
  "specialties.passport.desc": "Complete assistance in renewing your Brazilian passport during the low tax season",
  
  "specialties.company.title": "Company Formation",
  "specialties.company.desc": "Complete advisory for opening LLC and S Corp in the USA with the best tax regime choice",
  "specialties.bookkeeping.title": "Monthly Bookkeeping",
  "specialties.bookkeeping.desc": "Complete bookkeeping with accounting management, bookkeeping, and financial statements",
  "specialties.payroll.title": "Payroll",
  "specialties.payroll.desc": "Complete payroll and benefits management for your company",
  "specialties.businessConsulting.title": "Business Tax Consulting",
  "specialties.businessConsulting.desc": "Legal strategies for tax burden reduction and fiscal optimization of your business",
  "specialties.selfEmployed.title": "Tax Organization for Self-Employed",
  "specialties.selfEmployed.desc": "Specialized services for Self-Employed with complete organization of tax documentation",
  "specialties.regularization.title": "Tax Regularization",
  "specialties.regularization.desc": "Resolution of tax pending issues and regularization of tax situation with the IRS",
  "specialties.irsNotices.title": "IRS Notices",
  "specialties.irsNotices.desc": "Professional analysis and response to IRS notifications with authorized representation",
  "specialties.1099.title": "1099 Issuance",
  "specialties.1099.desc": "Preparation and submission of 1099 forms for independent contractors and service providers",

  // CTA
  "cta.title": "Ready to Regularize Your Tax Situation in the USA?",
  "cta.description": "Schedule a free consultation and discover how we can help you or your company",
  "cta.button": "Schedule Free Consultation",

  // Team
  "team.title": "Meet Our Team",
  "team.description": "Experienced professionals dedicated to your success",
  "team.support": "Support Team",
  "team.victor.role": "Enrolled Agent",
  "team.victor.education": "Berkeley Graduate",
  "team.victor.desc": "Specialist in business services, with extensive experience in tax planning and consulting for companies of all sizes",
  "team.denise.role": "Tax Preparation Specialist",
  "team.denise.education": "CTEC Certification",
  "team.denise.desc": "Specialist in individual services, focusing on income tax returns, ITIN, and services for Brazilians in the USA",
  "team.assistant": "Assistant",

  // Blog
  "blog.title": "Latest from the Blog",
  "blog.description": "Stay up to date with tax news and tips for your business in the USA",
  "blog.viewAll": "View All Articles",
  "blog.post1.title": "Tax Return 2024: Key Changes for Brazilians",
  "blog.post1.desc": "Check out the main changes in income tax returns in the USA this year and avoid problems with the IRS",
  "blog.post2.title": "How to Apply for ITIN Without Sending Passport to IRS",
  "blog.post2.desc": "Discover how our Acceptance Agent service facilitates your ITIN application with security",
  "blog.post3.title": "LLC or S Corp: Which to Choose for Your Company?",
  "blog.post3.desc": "Complete guide on how to open a company in the USA and choose the best tax regime",

  // Contact
  "contact.title": "Get in Touch",
  "contact.description": "We are ready to serve you. Contact us and schedule your free consultation today!",
  "contact.phone": "Phone",
  "contact.email": "Email",
  "contact.address": "Address",
  "contact.hours": "Business Hours",
  "contact.hoursWeekday": "Monday to Friday: 9:00 AM – 6:00 PM",
  "contact.hoursWeekend": "After hours and on Saturdays:",
  "contact.hoursScheduled": "By appointment only",
  "contact.reviewsOn": "reviews on Google",
  
  "contact.form.title": "Send Your Message",
  "contact.form.name": "Full Name",
  "contact.form.namePlaceholder": "Your full name",
  "contact.form.phone": "Phone",
  "contact.form.phonePlaceholder": "(123) 456-7890",
  "contact.form.email": "Email",
  "contact.form.emailPlaceholder": "your@email.com",
  "contact.form.reason": "Reason for Contact",
  "contact.form.reasonPlaceholder": "Select an option",
  "contact.form.message": "Message",
  "contact.form.messagePlaceholder": "Describe how we can help you...",
  "contact.form.characters": "characters",
  "contact.form.submit": "Send Message",
  "contact.form.sending": "Sending...",
  "contact.form.success": "Message sent successfully! We will contact you soon.",
  "contact.form.error": "Error sending message. Please try again.",
  "contact.form.required": "Please fill in all required fields.",
  "contact.form.maxLength": "Message cannot exceed 500 characters.",

  // Certifications
  "certifications.badge": "Official Credentials",
  "certifications.title": "Our Certifications",
  "certifications.description": "Professionals credentialed and authorized by the main tax agencies in the United States",
  "certifications.ea.title": "Enrolled Agent (EA)",
  "certifications.ea.desc": "Credentialed by the IRS to represent taxpayers in tax matters before the federal government",
  "certifications.ea.issuer": "U.S. Department of the Treasury",
  "certifications.efile.title": "IRS Authorized e-File Provider",
  "certifications.efile.desc": "Provider authorized by the IRS for electronic submission of income tax returns",
  "certifications.efile.issuer": "Internal Revenue Service",
  "certifications.acceptance.title": "Acceptance Agent",
  "certifications.acceptance.desc": "Agent authorized by the IRS for document authentication and ITIN application",
  "certifications.acceptance.issuer": "IRS ITIN Program",
  "certifications.ctec.title": "CTEC – California",
  "certifications.ctec.desc": "California Tax Education Council certification for tax preparation in the state of California",
  "certifications.ctec.issuer": "State of California",

  // Footer
  "footer.description": "Specialized tax and accounting solutions for Brazilians in the USA for over 11 years.",
  "footer.navigation": "Navigation",
  "footer.mainServices": "Main Services",
  "footer.quickContact": "Quick Contact",
  "footer.copyright": "© 2024 Amiraco Tax Service. All rights reserved.",

  // Mobile CTA
  "mobile.call": "Call Now",

  // TaxDome
  "taxdome.badge": "IRS-Approved Secure Portal",
  "taxdome.title": "TaxDome Client Portal",
  "taxdome.description": "The safest and most convenient way to send your tax documents. IRS-approved platform with end-to-end encryption.",
  "taxdome.loginTitle": "Access Your Account",
  "taxdome.loginDesc": "Log in to the client portal to send documents, track your return status, and communicate with us securely.",
  "taxdome.loginButton": "Access Client Portal",
  "taxdome.appTitle": "Download TaxDome App",
  "taxdome.appDesc": "Access the portal from your phone. Send documents, receive notifications, and track everything on the go.",
  "taxdome.downloadOn": "Download on the",
  "taxdome.getItOn": "Get it on",
  "taxdome.feature1Title": "Advanced Encryption",
  "taxdome.feature1Desc": "Your data protected with cutting-edge technology",
  "taxdome.feature2Title": "Secure Document Upload",
  "taxdome.feature2Desc": "Safer than email or WhatsApp",
  "taxdome.feature3Title": "IRS Approved",
  "taxdome.feature3Desc": "Certified and compliant platform",

  // Tutorial TaxDome
  "tutorial.backHome": "Back to Home",
  "tutorial.accessPortal": "Access Portal",
  "tutorial.badge": "Complete Tutorial",
  "tutorial.heroTitle": "How to Use the TaxDome Portal",
  "tutorial.heroDesc": "Learn step by step how to securely send your documents, track your return, and communicate with us through the portal.",
  "tutorial.loginNow": "Login Now",
  "tutorial.downloadApp": "Download App",

  "tutorial.whyTitle": "Why Use TaxDome?",
  "tutorial.whyDesc": "TaxDome is the safest and most efficient way to manage your tax documents",
  "tutorial.why1Title": "100% Secure",
  "tutorial.why1Desc": "End-to-end encryption protects all your documents and personal information",
  "tutorial.why2Title": "Save Time",
  "tutorial.why2Desc": "Send documents in seconds, no need to visit the office or mail anything",
  "tutorial.why3Title": "IRS Approved",
  "tutorial.why3Desc": "Certified platform fully compliant with US government requirements",

  "tutorial.stepsTitle": "Complete Step-by-Step Guide",
  "tutorial.stepsDesc": "Follow these simple instructions to use the TaxDome portal",
  "tutorial.stepLabel": "Step",
  "tutorial.prevStep": "Previous",
  "tutorial.nextStep": "Next",

  "tutorial.step1.title": "Access the Portal",
  "tutorial.step1.desc": "Log in to the client portal using your access credentials.",
  "tutorial.step1.detail1": "Go to amiracotax.taxdome.com or click the \"Access Portal\" button",
  "tutorial.step1.detail2": "Enter your registered email and password",
  "tutorial.step1.detail3": "If it's your first time, you'll receive an email invitation with instructions",

  "tutorial.step2.title": "Navigate the Dashboard",
  "tutorial.step2.desc": "Get to know the main areas of the portal and their features.",
  "tutorial.step2.detail1": "In the sidebar menu, access \"Documents\" to view and send files",
  "tutorial.step2.detail2": "In \"Tasks\", see what needs to be done and deadlines",
  "tutorial.step2.detail3": "Use \"Messages\" to communicate directly with us",

  "tutorial.step3.title": "Upload Your Documents",
  "tutorial.step3.desc": "Securely upload your tax documents.",
  "tutorial.step3.detail1": "Click on \"Documents\" then \"Upload\"",
  "tutorial.step3.detail2": "Drag files or click to select from your computer",
  "tutorial.step3.detail3": "You can send W-2, 1099, receipts, and any required documents",

  "tutorial.step4.title": "Communicate With Us",
  "tutorial.step4.desc": "Ask questions and receive updates through secure chat.",
  "tutorial.step4.detail1": "Access \"Messages\" to send questions or information",
  "tutorial.step4.detail2": "Receive notifications when we respond",
  "tutorial.step4.detail3": "All history is saved for your reference",

  "tutorial.step5.title": "Sign Documents",
  "tutorial.step5.desc": "Electronically sign your return and other documents.",
  "tutorial.step5.detail1": "When your return is ready, you'll receive a notification",
  "tutorial.step5.detail2": "Review the document and click \"Sign\"",
  "tutorial.step5.detail3": "Electronic signatures are legally valid and accepted by the IRS",

  "tutorial.appTitle": "Download the TaxDome App",
  "tutorial.appDesc": "Have the portal in the palm of your hand. Send documents, receive notifications, and track everything from your phone.",
  "tutorial.downloadOn": "Download on the",
  "tutorial.getItOn": "Get it on",
  "tutorial.app.feature1": "Push Notifications",
  "tutorial.app.feature1Desc": "Know immediately when something needs your attention",
  "tutorial.app.feature2": "Scan Documents",
  "tutorial.app.feature2Desc": "Use your phone camera to digitize documents",
  "tutorial.app.feature3": "Real-Time Chat",
  "tutorial.app.feature3Desc": "Communicate with us from anywhere",
  "tutorial.app.feature4": "Secure Access",
  "tutorial.app.feature4Desc": "Biometric authentication for maximum security",

  "tutorial.faqTitle": "Frequently Asked Questions",
  "tutorial.faqDesc": "Answers to the most common questions about the TaxDome portal",
  "tutorial.faq.q1": "How do I create my TaxDome account?",
  "tutorial.faq.a1": "You will receive an email invitation from Amiraco Tax Service. Click the link in the invitation and follow the instructions to create your password. If you didn't receive the invitation, contact us.",
  "tutorial.faq.q2": "I forgot my password. How do I recover it?",
  "tutorial.faq.a2": "On the login page, click \"Forgot password\" and enter your email. You will receive a link to reset your password. If you have problems, contact us.",
  "tutorial.faq.q3": "What types of files can I upload?",
  "tutorial.faq.a3": "You can upload PDF, images (JPG, PNG), Word and Excel documents. Maximum file size is 25MB. For larger files, contact us.",
  "tutorial.faq.q4": "Is the portal really secure?",
  "tutorial.faq.a4": "Yes! TaxDome uses end-to-end encryption, the same technology used by banks. The platform is IRS-approved and meets all data security requirements.",
  "tutorial.faq.q5": "Can I access the portal from my phone?",
  "tutorial.faq.a5": "Yes! You can access via your phone's browser or download the TaxDome app from the App Store (iPhone) or Google Play (Android) for an even better experience.",

  "tutorial.ctaTitle": "Ready to Get Started?",
  "tutorial.ctaDesc": "Access the portal now and send your documents securely. If you need help, we're here for you!",
  "tutorial.needHelp": "Need Help?"
};

export default translations;
